import ROUTE_PATH from "../constant/route";
import Login from "../pages/Login";
import VerifyOTP from "../pages/VerifyOTP";
import UnAuthentication from "../pages/UnAuthentication";
import { createBrowserRouter, Navigate } from "react-router-dom";
import HospicashInsurance from "../pages/HospicashInsurance";
import WellnessServices from "../pages/WellnessServices";
import ComprehensiveInsuranceManagement from "../pages/ComprehensiveInsuranceManagement";
import MobileDashboard from "../pages/MobileDashboard";
import TermsMobile from "../pages/MobileDashboard/termsMobile";
import SupportMobile from "../pages/MobileDashboard/supportMobile";
import PublicRoute from "./PublicRoute";
import PrivateRoute from "./PrivateRoute";
import Payment from "../pages/payment";
import PaymentSuccess from "../pages/PaymentResponse/paymentSuccess";
import PaymentFailure from "../pages/PaymentResponse/paymentFailure";
 

const routesConfig = createBrowserRouter([
  {
    path: ROUTE_PATH.LOGIN,
    element: (
      <PublicRoute>
        <Login />
      </PublicRoute>
    ),
  },
  {
    path: ROUTE_PATH.VERIFY_OTP,
    element: (
      <PublicRoute>
        <VerifyOTP />
      </PublicRoute>
    ),
  },
  {
    path: ROUTE_PATH.PAYMENT,
    element: (
      <PrivateRoute>
        <Payment />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTE_PATH.SUCCESS_PAYMENT,
    element: (
      <PrivateRoute>
        <PaymentSuccess />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTE_PATH.FAILURE_PAYMENT,
    element: (
      <PrivateRoute>
        <PaymentFailure />
      </PrivateRoute>
    ),
  },
  // {
  //   path: ROUTE_PATH.HOSPICASH,
  //   element: (
  //     <PrivateRoute>
  //       <HospicashInsurance />
  //     </PrivateRoute>
  //   ),
  // },
  {
    path: ROUTE_PATH.WELLNESS,
    element: (
      <PrivateRoute>
        <WellnessServices />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTE_PATH.COMPREHENSIVE,
    element: (
      <PrivateRoute>
        <ComprehensiveInsuranceManagement />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTE_PATH.DASHBOARD,
    element: (
      <PrivateRoute>
        <MobileDashboard />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTE_PATH.TERM_CONDITION,
    element: (
      <PrivateRoute>
        <TermsMobile />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTE_PATH.SUPPORT,
    element: (
      <PrivateRoute>
        <SupportMobile />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTE_PATH.UN_AUTH, // Standalone route for unauthorized access
    element: (
      <PublicRoute>
        <UnAuthentication />
      </PublicRoute>
    ),
  },
  {
    path: ROUTE_PATH.PAGE404, // Catch-all route for undefined paths
    element: <Navigate to={ROUTE_PATH.UN_AUTH} />,
  },
]);

export default routesConfig;
